import React from 'react'
import ProfileAvatar from '../../components/AdminDashboard/global/ProfileAvatar';
import NavBtn from '../../components/Global/NavBtn';
import { FaBars } from 'react-icons/fa';

const MobileNavBar = ({toggleNav}) => {
    return (
        <div className='hidden mobile:block w-full h-[88px]'>
            <div className='hidden mobile:flex justify-between items-center fixed px-6 h-[88px] py-5 top-0 left-0 w-screen bg-white z-[900] [box-shadow:0px_4px_12px_rgba(0,0,0,0.16)]'>
                <ProfileAvatar />
                
                <NavBtn onClick={toggleNav}>
                    <FaBars size={32} color="#000" />
                </NavBtn>             
            </div>    
        </div>
    )
}

export default MobileNavBar